import React from "react"
import { YearProvider } from "./src/context/YearContext"

export const wrapRootElement = ({ element }) => {
  return <YearProvider>{element}</YearProvider>
}
